import { useEffect, useState } from "react";
import { Activity, Loader2, Clock, LogIn, LogOut } from "lucide-react";
import api from "../../lib/api";

function formatDuration(secs) {
  if (secs == null) return "—";
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m ${s}s`;
  return `${s}s`;
}

export default function SessionsAdminPage() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/sessions?limit=500").then((r) => setSessions(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-sessions-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="overline mb-1">Activity Logs</div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold flex items-center gap-3">
            <Activity className="w-6 h-6 text-amber-500" /> Login Activity
          </h1>
        </div>
        <div className="text-sm text-slate-600 font-mono">
          {sessions.filter((s) => !s.logout_at).length} active · {sessions.length} total
        </div>
      </div>

      <div className="bg-white border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left p-3 font-semibold">Staff Name</th>
              <th className="text-left p-3 font-semibold">Email</th>
              <th className="text-left p-3 font-semibold">Role</th>
              <th className="text-left p-3 font-semibold">Login Date / Time</th>
              <th className="text-left p-3 font-semibold">Logout Time</th>
              <th className="text-right p-3 font-semibold">Duration</th>
              <th className="text-left p-3 font-semibold">IP</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((s) => (
              <tr key={s.id} className={`border-t border-slate-200 ${!s.logout_at ? "bg-emerald-50/40" : ""}`}>
                <td className="p-3 font-semibold">
                  {s.user_name}
                  {!s.logout_at && <span className="ml-2 inline-block w-2 h-2 bg-emerald-500 rounded-full pulse-dot" title="Active" />}
                </td>
                <td className="p-3 font-mono text-xs">{s.user_email}</td>
                <td className="p-3">
                  <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-1 ${
                    s.user_role === "admin" ? "bg-amber-500 text-slate-900" : "bg-slate-200 text-slate-700"
                  }`}>{s.user_role}</span>
                </td>
                <td className="p-3 text-xs">
                  <div className="flex items-center gap-1.5">
                    <LogIn className="w-3 h-3 text-emerald-500" />
                    {new Date(s.login_at).toLocaleString("en-IN")}
                  </div>
                </td>
                <td className="p-3 text-xs">
                  {s.logout_at ? (
                    <div className="flex items-center gap-1.5">
                      <LogOut className="w-3 h-3 text-slate-500" />
                      {new Date(s.logout_at).toLocaleString("en-IN")}
                    </div>
                  ) : (
                    <span className="text-emerald-600 font-bold text-xs">● LIVE</span>
                  )}
                </td>
                <td className="p-3 text-right font-mono text-xs">
                  <div className="inline-flex items-center gap-1">
                    <Clock className="w-3 h-3 text-slate-400" />
                    {formatDuration(s.duration_seconds)}
                  </div>
                </td>
                <td className="p-3 font-mono text-xs text-slate-500">{s.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading && <div className="p-12 text-center text-slate-500"><Loader2 className="w-5 h-5 animate-spin inline" /></div>}
        {!loading && sessions.length === 0 && (
          <div className="p-12 text-center text-slate-500 text-sm">No activity yet.</div>
        )}
      </div>
    </div>
  );
}
